import { createContext, useContext, useReducer, useEffect } from "react";

const STORAGE_KEY = "agape_cart_v1";
const CartContext = createContext(null);

function cartReducer(state, action) {
  switch (action.type) {
    case "ADD_ITEM": {
      const exists = state.some((i) => i.cartItemId === action.payload.cartItemId);
      if (exists) return state;
      return [...state, action.payload];
    }
    case "REMOVE_ITEM":
      return state.filter((i) => i.cartItemId !== action.payload);
    case "CLEAR_CART":
      return [];
    case "LOAD":
      return action.payload;
    default:
      return state;
  }
}

export function CartProvider({ children }) {
  const [items, dispatch] = useReducer(cartReducer, []);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) dispatch({ type: "LOAD", payload: JSON.parse(stored) });
    } catch {}
  }, []);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (item) => dispatch({ type: "ADD_ITEM", payload: item });
  const removeItem = (id) => dispatch({ type: "REMOVE_ITEM", payload: id });
  const clearCart = () => dispatch({ type: "CLEAR_CART" });

  const itemCount = items.length;

  const getSubtotal = () =>
    items.reduce((sum, item) => {
      const p = item.priceNumeric || 0;
      if (item.category === "suite" || item.category === "villa")
        return sum + p * (item.nights || 1);
      if (item.category === "pavilion")
        return sum + p * (item.guests || 1);
      return sum + p;
    }, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, itemCount, getSubtotal }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  const ctx = useContext(CartContext);
  if (!ctx) throw new Error("useCart must be used inside CartProvider");
  return ctx;
}
